'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildWelcomeMessage = buildWelcomeMessage;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _immutable = require('immutable');

var _Message = require('conversations-schema/records/Message');

var _Message2 = _interopRequireDefault(_Message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildWelcomeMessage() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var defaults = (0, _immutable.Map)({
    createdAt: Number(_I18n2.default.moment.portalTz()),
    initialMessage: _I18n2.default.text('default.initialMessage'),
    askForEmailMessage: _I18n2.default.text('default.askForEmailMessage')
  });

  return (0, _Message2.default)(defaults.merge((0, _immutable.fromJS)(data)));
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/factories/MessageFactory.js
// module id = 120
// module chunks = 0 1